import React from 'react';
import DashedLine from '@components/DashedLine';
import * as styles from './LoadMoreRates.module.scss';
import classNames from 'classnames';
import Plus from './plus.svg';
import tracker from '@utils/tracker';

export default function LoadMoreRates({
  hasInitialData,
  forceHide,
  errors,
  canLoadMore,
  isLoading,
  loadMore
}) {
  const isDisabled = !!errors?.validation;

  return forceHide || !hasInitialData || !canLoadMore ? null : (
    <div className={classNames('load-more-rates', styles.wrapper)}>
      <DashedLine
        direction="horizontal"
        className={styles.dash}
      />
      <button
        className={classNames(styles.button, {
          [styles.loading]: isLoading,
          [styles.disabled]: isDisabled
        })}
        onClick={() => {
          if (!isLoading && !isDisabled) {
            loadMore();
            tracker.track(tracker.actions.LOAD_MORE_RATES);
          }
        }}
      >
        {isLoading ? (
          'Loading'
        ) : (
          <>
            <Plus />
            Load more rates
          </>
        )}
      </button>
      <DashedLine
        direction="horizontal"
        className={styles.dash}
      />
    </div>
  );
}
